import { render, staticRenderFns } from "./OrderDetailsShipment.vue?vue&type=template&id=82f5d010&"
import script from "./OrderDetailsShipment.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports